<!-- <div class="flex flex-column h-screen">

  <header>
    <app-header [showHeader]="(showHeader$ | async) ?? false" ...></app-header>
  </header>


  <div *ngIf="isOffline" class="bg-cyan-600 text-white text-center py-2">
    <p class="m-0">You are offline. Some features may not be available.</p>
  </div>


  <div class="flex flex-1 overflow-hidden">

    <aside class="flex-none h-full overflow-y-auto border-right-1 surface-border"
           [ngClass]="{'hidden': !showMenu || screenService.isMobile, 'block': showMenu && !screenService.isMobile}">
      <app-side-bar></app-side-bar>
    </aside>


    <main class="flex-1 overflow-auto surface-ground">
      <router-outlet></router-outlet>
      <div class="flex justify-content-center align-items-center py-8" *ngIf="loading">
        <app-ll-loader size="page"></app-ll-loader>
      </div>
    </main>
  </div>


  <app-footer *ngIf="showFooter"></app-footer>
</div> -->

<!-- <router-outlet></router-outlet>
<ng-container *ngIf="router.url !== '/login';else loginPage">
    <div class="container">
      <div class="header">
        <app-header></app-header>
      </div>
      <app-side-bar></app-side-bar>
      <div class="content" #sidebarspace>
        <router-outlet></router-outlet>
      </div>
      <div class="footer">
        <app-footer></app-footer>
      </div>
    </div>
  </ng-container>
  <ng-template #loginPage>
    <router-outlet></router-outlet>
  </ng-template>  -->

<!-- <router-outlet></router-outlet> -->
<!-- <div class="container">
  <div class="header">
    <app-header *ngIf="showHeader"></app-header>
  </div>
  <app-side-bar *ngIf="showMenu"></app-side-bar>
  <div class="content" #sidebarspace>
    <div [ngStyle]="{'font-size.px': currentFontSize}">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="footer">
    <app-footer *ngIf="showFooter"></app-footer>
  </div>
</div> -->
<!--
<div class="news-div">
  <p-tag value="New"></p-tag>
</div>
 -->

<!-- <div class="news-div flex align-items-center justify-content-center">
  <p style="color: white;margin: 0;" class="p-0;m-0">BETA</p>
</div> -->

<!-- *ngIf="isOffline" -->
<!-- <p-toast [breakpoints]="{'920px': {width: '50%'},'768px': {width: '50%'},'480px': {width: '50%'}}" -->
<p-toast [preventOpenDuplicates]="true" [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'700ms'"
  [hideTransitionOptions]="'1000ms'" [showTransformOptions]="'translateX(100%)'" position="top-center"></p-toast>
<div *ngIf="isOffline" class="fixed top-0 left-0 right-0 pr-0 pl-0 pt-0 mb-2 m-0 text-center bg-cyan-600 text-white w-full" style="z-index: 9500;">
  <p class="m-2">You are offline. Some features may not be available.</p>
</div>
<app-slow-connection-indicator></app-slow-connection-indicator>
<!-- pull down to refresh: one gesture for the whole app, pages register what refresh means (PullToRefreshService) -->
<app-pull-to-refresh></app-pull-to-refresh>
<app-open-in-app-banner *ngIf="!isOffline" (visibleChange)="appBannerVisible = $event"></app-open-in-app-banner>

<!-- "Approve WhatsApp access?" — a customer on WhatsApp asked LumberLinq's assistant for help on this user's account -->
<app-wa-approval *ngIf="showMenu && !isOffline"></app-wa-approval>
<!-- Toasts live at the TOP LEVEL, not inside <header class="header"> where they used to sit.
     That header is now position:sticky and takes a translateY transform when it auto-hides on
     scroll — and a transformed element becomes the containing block for its position:fixed
     descendants. Left inside, every one of these toasts would have been positioned relative to
     the header instead of the viewport AND would have slid off-screen with it. They are overlays
     with no layout contribution, so their place in the DOM is free to move. -->
<p-toast key="billingDueToast" [breakpoints]="{
    '920px': { width: '50%' },
    '768px': { width: '50%' },
    '480px': { width: '50%' },
  }" [preventOpenDuplicates]="true" [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'700ms'"
  [hideTransitionOptions]="'1000ms'" [showTransformOptions]="'translateX(100%)'" position="top-center"></p-toast>

<p-toast key="expiredToast" [breakpoints]="{
    '920px': { width: '50%' },
    '768px': { width: '50%' },
    '480px': { width: '50%' },
  }" [preventOpenDuplicates]="true" [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'700ms'"
  [hideTransitionOptions]="'1000ms'" [showTransformOptions]="'translateX(100%)'" position="top-center"></p-toast>

<p-toast key="overDueToast" [breakpoints]="{
    '920px': { width: '50%' },
    '768px': { width: '50%' },
    '480px': { width: '50%' },
  }" [preventOpenDuplicates]="true" [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'700ms'"
  [hideTransitionOptions]="'1000ms'" [showTransformOptions]="'translateX(100%)'" position="top-center"></p-toast>

<p-toast key="logout-toast" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="top-center"></p-toast>

<p-toast key="shareLink" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="top-center"></p-toast>

<p-toast key="saving" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="top-center"></p-toast>

<p-toast key="plan-limit-toast" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="top-center"></p-toast>

<p-toast key="rate-limit-toast" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="top-center"></p-toast>

<p-toast key="subscription-toast" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="top-center"></p-toast>

<p-toast key="sidebar-toast" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="bottom-right"></p-toast>

<p-toast key="push-notification-toast" [preventOpenDuplicates]="true" [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'700ms'" [hideTransitionOptions]="'1000ms'" position="top-center">
  <ng-template let-message pTemplate="message">
    <div class="push-toast-body" (click)="onPushToastClick()">
      <i class="pi pi-bell push-toast-icon"></i>
      <div class="push-toast-text">
        <div class="push-toast-summary">{{ message.summary }}</div>
        <div class="push-toast-detail">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>

<div class="container" [ngClass]="{ 'pt-4': isOffline || appBannerVisible }">
  <header class="header">
    <app-header [showHeader]="(showHeader$ | async) ?? false" [visibilityCondition]="showMenu"
      [showLogo]="(showLogo$ | async) ?? false" [showFontSize]="showFontSize" [showMenuButton]="showMenuButton"
      [showDayNightScheme]="showDayNightScheme" [showUserProfileButton]="showUserProfileButton"></app-header>
  </header>

  <div class="offline-prefetch-bar" *ngIf="offlinePrefetchService.isRunning()">
    <div class="offline-prefetch-bar-fill"></div>
  </div>
  <!-- Offline writes being sent (phone app only — the sync engine only runs there). UPLOAD_PROGRESS_PLAN.md step 3. -->
  <div class="offline-syncing-note" *ngIf="syncEngineService.syncingCount() > 0" role="status" aria-live="polite">
    <i class="pi pi-sync pi-spin" aria-hidden="true"></i>
    <span>{{ syncEngineService.syncingCount() }} {{ (syncEngineService.syncingCount() === 1 ? 'offline.itemSyncing' : 'offline.itemsSyncing') | t }}</span>
  </div>
  <div class="offline-sync-checklist" *ngIf="offlinePrefetchService.isRunning()">
    <span class="offline-sync-checklist-title">{{ 'common.preparingOfflineData' | t }}</span>
    <ul>
      <li *ngFor="let area of offlinePrefetchService.syncAreas()" [class]="'sync-status-' + area.status">
        <i class="pi" [ngClass]="{
          'pi-check-circle': area.status === 'done',
          'pi-spin pi-spinner': area.status === 'running',
          'pi-exclamation-triangle': area.status === 'error',
          'pi-circle': area.status === 'pending'
        }"></i>
        <span>{{ area.labelKey | t }}</span>
        <!-- Live count for a long area (2026-09-29): each new number slides in (the *ngFor recreates it). -->
        <span class="sync-count" *ngIf="area.total">
          <span class="sync-count-num" *ngFor="let n of [area.done ?? 0]">{{ n }}</span>
          <span class="sync-count-total">/ {{ area.total }}</span>
          <span class="sync-count-bar"><span [style.width.%]="((area.done ?? 0) / area.total) * 100"></span></span>
        </span>
      </li>
    </ul>
  </div>

  <!-- <div class="main">
    <aside class="sidebar">
      <app-side-bar *ngIf="showMenu"></app-side-bar>
    </aside>

    <main class="main-content">
      <div>
        <div [@routeAnimations]="prepareRoute(outlet)">
          <p-button icon="pi pi-cog" styleClass="p-button-sm"
            class="layout-config-button p-link" (click)="op.toggle($event)"></p-button>
          <router-outlet #outlet="outlet"></router-outlet>
        </div>

        <div class="spinner-container" *ngIf="loading">
          <app-ll-loader size="page"></app-ll-loader>
        </div>
      </div>
    </main>
  </div> -->

  <div class="flex flex-row flex-1">
    <aside class="flex-none">
      <app-side-bar *ngIf="showMenu"></app-side-bar>
    </aside>

    <main class="flex-grow-1 flex flex-column p-0" [class.pb-7]="showFooter">
      <div class="route-shell" [class.dashboard-active]="isDashboardRoute">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </main>
  </div>

  <!-- <footer class="border-3 border-primary-500"> -->
  <app-footer *ngIf="showFooter"></app-footer>
  <!-- </footer> -->

  <!-- Support asks to see the person's screen: a window on whatever page they are on -->
  <app-screen-support-prompt></app-screen-support-prompt>
</div>

<!-- ── Legal Update Banner ── -->
<div class="legal-update-banner" *ngIf="showLegalUpdateBanner && showMenu">
  <div class="legal-update-banner-content">
    <i class="pi pi-shield"></i>
    <div class="legal-update-banner-text">
      <strong>{{ (legalHasUpdated ? 'legal.bannerTitleUpdated' : 'legal.bannerTitleNew') | t }}</strong>
      {{ (legalHasUpdated ? 'legal.bannerLeadUpdated' : 'legal.bannerLeadNew') | t }}
      <span *ngFor="let d of legalOutdatedDocs; let last = last">
        <a [routerLink]="'/legal/' + getDocRoute(d.documentType)" target="_blank">{{ d.documentType | titlecase }}</a><span *ngIf="!last">, </span>
      </span>.
    </div>
    <!-- A real button, not another inline link: the old "Review in your profile" anchor looked
         identical to the document links beside it (so it read as an 8th document rather than an
         action) AND pointed at /company?tab=legal — a tab that does not exist, leaving users with
         no way at all to accept. -->
    <button pButton type="button" icon="pi pi-check-circle" label="Review &amp; Accept"
      class="p-button-sm legal-update-banner-cta" (click)="openLegalAcceptance()"></button>
    <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm legal-update-banner-dismiss"
      pTooltip="Dismiss for now" (click)="dismissLegalBanner()"></button>
  </div>
</div>

<!-- ── Legal acceptance dialog ──────────────────────────────────────
     Opened from the banner's "Review & Accept". Lists every document that is actually
     outstanding for this account, each openable in a new tab, behind a single consent
     checkbox -> ONE recordBatchAcceptance() call. Acceptance is stored server-side against
     the account, so unlike the banner's dismiss (localStorage, wiped by logout's
     localStorage.clear()) it does not come back on the next login or on another device. -->
<p-dialog [header]="(legalHasUpdated ? 'legal.dialogTitleUpdated' : 'legal.dialogTitleNew') | t" [(visible)]="showLegalAcceptDialog" [modal]="true"
  [style]="{ width: '90vw', 'min-width': '280px', 'max-width': '560px' }" [draggable]="false"
  [resizable]="false" [baseZIndex]="25000" appendTo="body" (onHide)="legalAcceptChecked = false">
  <p class="mt-0 mb-3 text-color-secondary">
    {{ (legalHasUpdated ? 'legal.dialogBodyUpdated' : 'legal.dialogBodyNew') | t }}
  </p>

  <div class="legal-accept-row" *ngFor="let d of legalOutdatedDocs">
    <div class="legal-accept-row-main">
      <span class="legal-accept-name">{{ d.documentType | titlecase }}</span>
      <span class="legal-accept-version">v{{ d.latestVersion }}</span>
    </div>
    <a [routerLink]="'/legal/' + getDocRoute(d.documentType)" target="_blank"
      class="legal-accept-open">{{ 'Open' | t }} <i class="pi pi-external-link"></i></a>
  </div>

  <div class="flex align-items-start gap-2 mt-4">
    <p-checkbox [(ngModel)]="legalAcceptChecked" [binary]="true" inputId="legalAcceptAll"></p-checkbox>
    <label for="legalAcceptAll" class="cursor-pointer">
      I have read and agree to all the documents listed above.
    </label>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Later" styleClass="p-button-text" (click)="showLegalAcceptDialog = false"
      [disabled]="savingLegalAcceptance"></p-button>
    <p-button icon="pi pi-check" label="Accept All" (click)="acceptAllLegalDocs()"
      [disabled]="!legalAcceptChecked || savingLegalAcceptance" [loading]="savingLegalAcceptance"></p-button>
  </ng-template>
</p-dialog>

<!-- ── AI Chat Widget (sidebar only — FAB merged into SpeedDial) ── -->
<app-ai-chat-widget *ngIf="showMenu && aiChatEnabled" [hideFab]="true"></app-ai-chat-widget>

<!-- ── SpeedDial FAB: Linc AI + Support (bottom-right) ── -->
<!-- Lifted above the tally status bar's 44px fixed footer on /new-tallysheet routes so it doesn't overlap the Save button -->
<!-- 2026-10-07 (owner request): the round Linc AI + Support button is hidden on every page (it was annoying). The code is kept, only commented out; to bring it back remove this comment. Support Tickets stays in the menu (Support); Linc AI help can be reopened through ai-chat-widget.toggleChat(). -->
<!--
<p-speedDial *ngIf="showMenu && !isOffline" [model]="speedDialItems" direction="up"
  [style]="{'position':'fixed','bottom': isTallySheetRoute ? '5.75rem' : 'calc(3.75rem + env(safe-area-inset-bottom, 0px) + var(--app-dock-extra, 0px))','right':'1.5rem','z-index':'9000'}"
  buttonStyleClass="tms-speed-dial-btn"
  showIcon="pi pi-bars" hideIcon="pi pi-times">
</p-speedDial>
-->

<!-- ── Ambient HTTP-activity bar — thin, no backdrop, never blocks a click. Deliberately kept
     well below both the route loader (9999) and the routeGuard confirm dialog (10000) below,
     and structurally can't bury either since it has no backdrop of its own. Separate mechanism
     from the route loader: this covers any API call in flight, not just navigation. Suppressed
     while offlinePrefetchService.isRunning() — that sync already renders its own bar + checklist
     above (same HTTP calls would otherwise light up both at once, showing two progress bars for
     one operation). -->
<div class="http-activity-bar" *ngIf="(httpActivityVisible$ | async) && !offlinePrefetchService.isRunning()"></div>

<!-- ── Global Full-Page Route Loader ── -->
<div class="global-page-loader" *ngIf="loading" @fadeInOut>
  <div class="gpl-backdrop"></div>
  <div class="gpl-card">
    <app-ll-loader size="card" [label]="'Loading...' | t"></app-ll-loader>
  </div>
</div>

<p-confirmDialog key="deleteConfirmDialogCommon"></p-confirmDialog>
<p-confirmDialog key="routeGuard" appendTo="body" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="sessionExpiredDialog" appendTo="body" [baseZIndex]="20000"></p-confirmDialog>
<p-confirmDialog key="unsyncedLogoutConfirm" appendTo="body" [baseZIndex]="20000"></p-confirmDialog>

<p-dialog [header]="'auth.sessionExpired' | t" [(visible)]="showSessionExpiredDialog" [modal]="true" [closable]="false"
  [style]="{ width: '70vw', 'min-width': '280px', 'max-width': '420px' }" [draggable]="false" [resizable]="false"
  [baseZIndex]="25000" appendTo="body">
  <div class="flex align-items-start gap-3 py-1">
    <i class="pi pi-shield text-primary" style="font-size: 1.5rem; margin-top: 2px;"></i>
    <p class="m-0">{{ sessionExpiredMessage }}</p>
  </div>
  <ng-template pTemplate="footer">
    <p-button [label]="'common.stayOnPage' | t" styleClass="p-button-text"
      (click)="rejectSessionExpiredDialog()"></p-button>
    <p-button icon="pi pi-sign-in" [label]="'common.signInAgain' | t" (click)="acceptSessionExpiredDialog()"></p-button>
  </ng-template>
</p-dialog>

<!-- Shown when THIS session's own 401 traces to a backend session-kick marker — i.e. this
     device was force-logged-out because the same account confirmed "log out that device" from
     a login elsewhere. Distinct from the generic session-expired dialog above so the user knows
     WHY, with the same device-card language ConfirmLogoutDevicesComponent already established. -->
<p-dialog [header]="'forcedLogout.header' | t" [(visible)]="showForcedLogoutDialog" [modal]="true" [closable]="false"
  [style]="{ width: '70vw', 'min-width': '280px', 'max-width': '420px' }" [draggable]="false" [resizable]="false"
  [baseZIndex]="25000" appendTo="body">
  <div class="flo-body">
    <i class="pi pi-shield flo-shield-icon"></i>
    <div class="flo-content" *ngIf="forcedLogoutInfo?.device; else forcedLogoutGeneric">
      <p class="flo-message">{{ 'forcedLogout.explanation' | t }}</p>
      <div class="flo-device-card">
        <div class="flo-device-row">
          <i [class]="forcedLogoutDeviceIcon(forcedLogoutInfo?.device) + ' flo-device-type-icon'"></i>
          <span class="flo-device-name">{{ forcedLogoutInfo?.device }}</span>
        </div>
        <div class="flo-location-row" *ngIf="forcedLogoutInfo?.location">
          <i class="pi pi-map-marker flo-location-icon"></i>
          <span class="flo-location-text">{{ forcedLogoutInfo?.location }}</span>
        </div>
      </div>
    </div>
    <ng-template #forcedLogoutGeneric>
      <div class="flo-content">
        <p class="flo-message">{{ 'forcedLogout.bodyGeneric' | t }}</p>
      </div>
    </ng-template>
  </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-sign-in" [label]="'forcedLogout.goToLogin' | t" (click)="acceptForcedLogoutDialog()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [header]="'Access Denied' | t" [(visible)]="showAccessDeniedDialog" [modal]="true" [closable]="true"
  (onHide)="closeAccessDeniedDialog()" [style]="{ width: '70vw', 'min-width': '280px', 'max-width': '460px' }"
  [draggable]="false" [resizable]="false" [baseZIndex]="25000" appendTo="body">
  <div class="flex align-items-center gap-3 py-2">
    <i class="pi pi-lock text-red-500" style="font-size: 1.6rem"></i>
    <p class="m-0">{{ accessDeniedMessage }}</p>
  </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" [label]="'Ok' | t" (click)="closeAccessDeniedDialog()"></p-button>
  </ng-template>
</p-dialog>

<!-- Plan limit reached (402) / feature not available (403 PLAN_FEATURE_DISABLED) — a modal, not a
     toast, on purpose: this fires after the user has already filled out a create form, and is a
     hard, non-retryable block, not a transient/glanceable event. Driven by PlanLimitDialogService,
     opened from the HTTP interceptor's handleError() — same "one shared service + one root-mounted
     dialog" pattern as the Access Denied dialog right above. -->
<p-dialog [header]="('planLimit.dialogTitle' | t) + ': ' + planLimitLabel" [(visible)]="showPlanLimitDialog"
  [modal]="true" [closable]="true" (onHide)="closePlanLimitDialog()"
  [style]="{ width: '70vw', 'min-width': '280px', 'max-width': '460px' }" [draggable]="false"
  [resizable]="false" [baseZIndex]="25000" appendTo="body">
  <div class="flex align-items-center gap-3 py-2">
    <i class="pi pi-exclamation-triangle text-orange-500" style="font-size: 1.6rem"></i>
    <div>
      <p class="m-0" *ngIf="planLimitUsed != null && planLimitLimit != null">
        {{ ('planLimit.dialogUsage' | t).replace('{used}', '' + planLimitUsed).replace('{limit}', '' + planLimitLimit).replace('{feature}', planLimitLabel) }}
      </p>
      <p class="m-0" *ngIf="planLimitUsed == null || planLimitLimit == null">{{ planLimitMessage }}</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button *ngIf="planLimitManageRoute" [label]="('planLimit.manageButton' | t).replace('{feature}', planLimitLabel)"
      styleClass="p-button-outlined" (click)="goToPlanLimitManage()"></p-button>
    <p-button [label]="'planLimit.upgradeButton' | t" (click)="goToPlanLimitUpgrade()"></p-button>
  </ng-template>
</p-dialog>

<!-- Server error dialog (500/502/503/504) — self-contained, driven by ServerErrorDialogService -->
<app-server-error></app-server-error>

<!-- App-wide push-permission priming — shown once per device on first login for users who never
     went through the onboarding prompt (see AppComponent.maybePromptForPushPermission). -->
<app-enable-notifications-prompt
  [(visible)]="showEnableNotificationsPrompt"
  (done)="onEnableNotificationsPromptDone()"
></app-enable-notifications-prompt>

<!-- Give Feedback dialog + optional Dashboard prompt / store review request. Logged-in only;
     the prompt and store review stay off until a SUPER_ADMIN/ROOT enables them. -->
<app-feedback-host *ngIf="showMenu"></app-feedback-host>
<app-shared-files-sheet *ngIf="showMenu"></app-shared-files-sheet>

<p-dialog key="errorDialog" [header]="'Something went wrong' | t" [(visible)]="showErrorDialog" [modal]="true"
  [style]="{ width: '70vw', 'min-width': '280px', 'max-width': '600px' }" [draggable]="false" [resizable]="false">
  <p class="m-0">
    {{ errorMessage }}
  </p>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="showErrorDialog = false" [label]="'Ok' | t"
      styleClass="p-button-text"></p-button>
  </ng-template>
</p-dialog>

<div class="cookie-consent" *ngIf="showCookieConsent">
  <div class="cookie-icon">
    <i class="pi pi-shield"></i>
  </div>
  <div class="cookie-copy">
    <strong>{{ (isNativeApp ? 'cookie.titleApp' : 'cookie.title') | t }}</strong>
    <span>{{ (isNativeApp ? 'cookie.descApp' : 'cookie.desc') | t }}&nbsp;<a href="/licenses" class="cookie-privacy-link">{{ 'cookie.privacyLink' | t
        }}</a></span>
  </div>
  <div class="cookie-actions">
    <button pButton type="button" class="p-button-text p-button-sm" [label]="'cookie.reject' | t"
      (click)="rejectNonEssentialCookies()"></button>
    <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-sliders-h"
      [label]="'cookie.manage' | t" (click)="showCookieConsent = false; showCookiePreferences = true"></button>
    <button pButton type="button" class="p-button-sm" icon="pi pi-check" [label]="'cookie.acceptAll' | t"
      (click)="acceptAllCookies()"></button>
  </div>
</div>

<p-dialog [header]="'cookie.preferences' | t" [(visible)]="showCookiePreferences" [modal]="true"
  styleClass="cookie-dialog" [draggable]="false" [resizable]="false" [closeOnEscape]="true">
  <!-- GDPR note inside dialog -->
  <div class="cookie-gdpr-dialog-note mb-3">
    <i class="pi pi-info-circle mr-2 text-blue-500"></i>
    <span>{{ (isNativeApp ? 'cookie.gdprNoteApp' : 'cookie.gdprNote') | t }}</span>
    &nbsp;<a href="/licenses" class="cookie-privacy-link">{{ 'cookie.privacyLink' | t }}</a>
    <div class="text-400 text-xs mt-1">{{ 'cookie.dataController' | t }}</div>
  </div>

  <div class="cookie-preference-row">
    <div class="cookie-pref-info">
      <strong><i class="pi pi-lock mr-1" style="color: var(--primary-color)"></i>{{ 'cookie.essential' | t }}</strong>
      <p>{{ 'cookie.essentialDesc' | t }}</p>
    </div>
    <span class="cookie-always-on-badge"><i class="pi pi-check-circle"></i>{{ 'cookie.alwaysOn' | t }}</span>
  </div>
  <div class="cookie-preference-row">
    <div class="cookie-pref-info">
      <strong><i class="pi pi-cog mr-1" style="color: #1684AC"></i>{{ 'cookie.functional' | t }}</strong>
      <p>{{ 'cookie.functionalDesc' | t }}</p>
    </div>
    <span class="cookie-always-on-badge"><i class="pi pi-check-circle"></i>{{ 'cookie.alwaysOn' | t }}</span>
  </div>
  <div class="cookie-preference-row">
    <div class="cookie-pref-info">
      <strong><i class="pi pi-chart-bar mr-1" style="color: var(--primary-color)"></i>{{ 'cookie.analytics' | t
        }}</strong>
      <p>{{ 'cookie.analyticsDesc' | t }}</p>
    </div>
    <p-toggleswitch [(ngModel)]="analyticsCookiesEnabled"></p-toggleswitch>
  </div>
  <ng-template pTemplate="footer">
    <p-button [label]="'cookie.savePreferences' | t" icon="pi pi-check" styleClass="p-button-sm"
      (click)="saveCookiePreferences()"></p-button>
  </ng-template>
</p-dialog>

<!-- <p-drawer [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-config-sidebar w-20rem">
  <h5>Scale</h5>

  <p-slider [(ngModel)]="sliderValue" (onChange)="onSliderChange($event)"></p-slider>


  <p-toggleButton [(ngModel)]="isDarkThemeEnabled" offIcon="pi pi-moon" onIcon="pi pi-sun" (onChange)="updateTheme()"
    class="themebutton" *ngIf="showDayNightScheme">
  </p-toggleButton>
</p-drawer> -->